import { makeStyles } from "@material-ui/core/styles";
import { DRAWER_WIDTH, HEADER_HEIGHT } from "../../../../constants";

export const useStyles = makeStyles((theme) => ({
  container: {
    marginLeft: `${DRAWER_WIDTH}px`,
    width: `calc(100% - ${DRAWER_WIDTH}px)`,
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0px",
      width: "100%",
    },
    height: HEADER_HEIGHT,
  },
  userPopover: {
    minWidth: 200,
  },
  userInfoButton: {
    textTransform: "none",
    fontSize: theme.typography.pxToRem(15),
    padding: 0,
    color: theme.palette.primary.contrastText,
    fontWeight: theme.typography.fontWeightMedium,
    marginLeft: theme.spacing(2),
    lineHeight: "1rem",
  },
  toolbar: {
    height: HEADER_HEIGHT,
  },
  menuIcon: {
    color: theme.palette.primary.contrastText,
  },
}));
